import { useEffect, useState } from "react";
import api from "../api";

const getPluginsApi = async (filename, releasePath) => {
  if (!filename || !releasePath) {
    return [];
  }

  try {
    const res = await api.fetchManifest(`${releasePath}/${filename}`);
    const manifest = res?.data;
    return [manifest];
  } catch (e) {
    console.error("Error:", e);
  }
};

export default getPluginsApi;
